export default "/images/vendor/flag-icons/flags/4x3/mg.svg?5d294de1198203cd569a8f35ccae38e4";